import { render, staticRenderFns } from "./ShortLinkRouter.vue?vue&type=template&id=a5c338fa&scoped=true&"
import script from "./ShortLinkRouter.vue?vue&type=script&lang=js&"
export * from "./ShortLinkRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c338fa",
  null
  
)

export default component.exports